export default "__VITE_ASSET__517bVEuD__"